import { useLayoutEffect } from 'react'

export const useBlockScroll = (isBlocking = true) => {
  useLayoutEffect(() => {
    if (isBlocking) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'visible'
    }
  })
}
